module.exports = ":host {\n  width: 600px;\n  font-size: 16px;\n  line-height: 20px; }\n\n.btn {\n  right: 10px; }\n\n.content {\n  overflow: visible; }\n\n.buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\n.text {\n  background-color: #607d8b;\n  padding: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/ks-info-modal/ks-info-modal.component.scss
// module id = ./src/app/dashboard/ks-info-modal/ks-info-modal.component.scss
// module chunks = main